const stap2 = {

	init() {

		window.app.domStateReady(function() {
			document.getElementById('stap2form').submit();
		});

	}

};

export default stap2;
